export default "__VITE_ASSET__Dy2sPsi8__"